var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer",attrs:{"id":"footer_root"}},[_c('strong',[_vm._v("Copyright © 2020-2021 "),_c('a',{attrs:{"href":"https://dnc.group"}},[_vm._v("DNC Group")]),_vm._v(".")]),_vm._v(" All rights reserved. "),_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('b',[_vm._v("Version")]),_vm._v(" 1.11.0.21 ")])])
}]

export { render, staticRenderFns }